<div class="app-content">
    <router-outlet></router-outlet>
</div>
